import { type ReactNode } from 'react';
import { type SupportedLocale } from '@zep-us/i18n';
import { SelectRoot, SelectTrigger } from '@/ui_v3/components/select';
import { SingleSelectContent } from '@/ui_v3/components/select/SingleSelectContent';
import { SingleSelectOnDrawerUI } from '@/ui_v3/components/select/SingleSelectOnDrawerUI';
import { type SelectOption } from '@/ui_v3/components/select/type';
interface LanguageSelectorContentProps {
  variant: 'drawer' | 'select';
  options: SelectOption<SupportedLocale>[];
  currentLocale: SupportedLocale;
  isOpen: boolean;
  open: () => void;
  close: () => void;
  handleSelect: (value: SupportedLocale) => void;
  trigger: ReactNode;
}
export function LanguageSelectorContent({
  variant,
  options,
  currentLocale,
  isOpen,
  open,
  close,
  handleSelect,
  trigger
}: LanguageSelectorContentProps) {
  switch (variant) {
    case 'drawer':
      return <SingleSelectOnDrawerUI<SupportedLocale> hasDrawerHandle options={options} open={open} close={close} isOpen={isOpen} trigger={trigger} onSelect={value => {
        if (value && value !== currentLocale) {
          handleSelect(value);
        }
      }} value={currentLocale} />;
    case 'select':
      return <SelectRoot open={isOpen}>
          <SelectTrigger trigger={trigger} />
          <SingleSelectContent close={close} onSelect={value => {
          if (value && value !== currentLocale) {
            handleSelect(value);
          }
        }} options={options} className="z-channelTalk max-h-[310px] min-w-[200px] pr-none" align="end" value={currentLocale} showScrollbar />
        </SelectRoot>;
  }
}